<section class="ib-switch-sell-car-card-no-dispo">
    <header class="ib-switch-sell-car-card-no-dispo__header">
        <img src="/iberia-web-content/imagenes/switch-sell/car-no-dispo.png"
            class="ib-switch-sell-car-card-no-dispo__logo" alt="Logo">
    </header>

    <section class="ib-switch-sell-car-card-no-dispo__main">
        <section class="ib-switch-sell-car-card-no-dispo__info" [ngClass]="{ '--no-hotel-dispo': !hasHotelDispo }">
            <h1 class="ib-switch-sell-car-card-no-dispo__info__title">{{'ALP_SWITCH_SELL_CAR_TXT'|translate}}</h1>
            <div *ngIf="hasHotelDispo" class="ib-switch-sell-car-card-no-dispo__info__icons">
                <span class="ib-switch-sell-car-card-no-dispo__info__icons__icon">
                    <img src="/iberia-web-content/imagenes/switch-sell/budget-icon.png"
                        class="ib-switch-sell-car-card-no-dispo__info__icons__icon__logo" />
                </span>
                <span class="ib-switch-sell-car-card__icons__icon">
                    <img src="/iberia-web-content/imagenes/switch-sell/avis-icon.png"
                        class="ib-switch-sell-car-card-no-dispo__info__icons__icon__logo" />
                </span>
            </div>
            <ul class="ib-switch-sell-car-card-no-dispo__info__list">

                <li class="ib-switch-sell-car-card-no-dispo__info__list__item">
                    <img src="/iberia-web-content/imagenes/switch-sell/check.png" alt=""
                        class="ib-switch-sell-car-card-no-dispo__info__list__item__icon">
                    <p class="ib-switch-sell-car-card-no-dispo__info__list__item__text">
                        {{'ALP_SWITCH_SELL_CAR_CONDITION_TXT_2'|translate}}
                    </p>
                </li>

                <li class="ib-switch-sell-car-card-no-dispo__info__list__item">
                    <img src="/iberia-web-content/imagenes/switch-sell/check.png" alt=""
                        class="ib-switch-sell-car-card-no-dispo__info__list__item__icon">
                    <p class="ib-switch-sell-car-card-no-dispo__info__list__item__text">
                        {{'ALP_SWITCH_SELL_CAR_CONDITION_TXT_3'|translate}}
                    </p>
                </li>

                <li class="ib-switch-sell-car-card-no-dispo__info__list__item">
                    <img src="/iberia-web-content/imagenes/switch-sell/check.png" alt=""
                        class="ib-switch-sell-car-card-no-dispo__info__list__item__icon">
                    <p class="ib-switch-sell-car-card-no-dispo__info__list__item__text">
                        {{'ALP_SWITCH_SELL_CAR_CONDITION_TXT_4'|translate}}
                    </p>
                </li>

                <li class="ib-switch-sell-car-card-no-dispo__info__list__item">
                    <img src="/iberia-web-content/imagenes/switch-sell/check.png" alt=""
                        class="ib-switch-sell-car-card-no-dispo__info__list__item__icon">
                    <p class="ib-switch-sell-car-card-no-dispo__info__list__item__text">
                        {{'ALP_SWITCH_SELL_CAR_CONDITION_TXT_1'|translate}}
                    </p>
                </li>
             
            </ul>
        </section>



        <button class="ib-switch-sell-car-card-no-dispo__button"
            (click)="redirectToIbh()">{{'ALP_SWITCH_SELL_CAR_BTN'|translate}}</button>

        <div *ngIf="!hasHotelDispo" class="ib-switch-sell-car-card-no-dispo__icons">
            <span class="ib-switch-sell-car-card-no-dispo__icons__icon">
                <img src="/iberia-web-content/imagenes/switch-sell/budget.svg"
                    class="ib-switch-sell-car-card-no-dispo__icons__icon__logo" />
            </span>
            <span class="ib-switch-sell-car-card-no-dispo__icons__icon">
                <img src="/iberia-web-content/imagenes/switch-sell/avis.svg"
                    class="ib-switch-sell-car-card-no-dispo__icons__icon__logo" />
            </span>
        </div>
    </section>
</section>